import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Button } from 'react-bootstrap'
import useAppointmentTypesState from '../../../stores/Configuration/useAppointmentTypesState'
import CabinSelect from './CabinSelect'
import styled from 'styled-components'

const StyledButton = styled(Button)`
margin-top:1.5rem;
margin-bottom:1.5rem;
  @media screen and (max-width: 767px) {
      width:100%;
`
const AppointmentTypeAssignedCabinsForm = () => {
  const { t } = useTranslation()
  const { handleSubmit, error, success, resetStates } =
    useAppointmentTypesState()

  useEffect(() => {
     return () =>  resetStates() 
  }, [resetStates])

  return (
    <>
      <CabinSelect />
      <StyledButton
        className='btn-extra-padding'
        onClick={() => handleSubmit('assignedCabins')}
      >
        {t('saveButton')}
      </StyledButton>
      {error && <Alert variant='danger'>{error}</Alert>}
      {success && (
        <Alert variant='success' className='my-2'>
          {success}
        </Alert>
      )}
    </>
  )
}

export default AppointmentTypeAssignedCabinsForm
